import { useMutation, useQueryClient } from 'react-query';

import { FETCH_TAGS, ATTACHMENT } from '../../constants/endpoints';
import api from '../../utils/api';
import { CAMPAIGN_SUBMISSION_DETAILS, CAMPAIGN_SUBMISSIONS_LIST } from './queries';

const updateAttachmentTags = ({ attachmentId, data }) =>
  api.put(`${ATTACHMENT}/${attachmentId}/tags`, data);
export const useUpdateAttachmentTags = () => {
  const queryClient = useQueryClient();

  return useMutation(updateAttachmentTags, {
    onSuccess: (data, variables) => {
      if (variables?.data?.newTags?.length) {
        // if we are creating a new tag -> refetch tags list
        queryClient.invalidateQueries(FETCH_TAGS);
      }
      // could do optimistic update to add new tag list item -> will need to look into it more
      queryClient.invalidateQueries([CAMPAIGN_SUBMISSION_DETAILS]);
    }
  });
};

const updateAttachmentDetails = ({ attachmentId, data }) =>
  api.patch(`${ATTACHMENT}/${attachmentId}`, data);
export const useUpdateAttachmentDetails = () => {
  const queryClient = useQueryClient();

  return useMutation(updateAttachmentDetails, {
    onSuccess: () => {
      queryClient.invalidateQueries(CAMPAIGN_SUBMISSION_DETAILS);
      queryClient.invalidateQueries(CAMPAIGN_SUBMISSIONS_LIST);
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useAttachmentData.js